import { DocumentInformationDrawer } from '@modules/documents/components/DocumentInformationDrawer';
import { ProjectSectionListItem } from '@modules/projects/components/Sections/ProjectSectionList';
import { ListItemButton, ListItemProps, ListItemText, Stack, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { DocumentFragmentFragment, ProjectTaskFragmentFragment, ProjectTaskStatus } from 'src/gql/index';
import { getFileNameWithoutExtension } from '../../folders/utils/folderUtils';
import { useTaskFormatters } from '../useTaskFormatters';

type DocumentListItemProps = ListItemProps & {
  task: ProjectTaskFragmentFragment;
  document: DocumentFragmentFragment;
  onOpenTask?: (task: ProjectTaskFragmentFragment, projectId: number) => void;
  secondaryAction?: React.ReactNode;
  assigneesAdornment?: React.ReactNode;
};


export const DocumentTaskListItem = (props: DocumentListItemProps) => {
  const { document, task, onOpenTask, secondaryAction, assigneesAdornment, ...listItemProps } = props;
  const { formatMessage } = useIntl();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { formatTaskSecondaryText } = useTaskFormatters();
  const fileName = getFileNameWithoutExtension(document.fileName);
  const isOverdue = task.status !== ProjectTaskStatus.Done && (task.dueDate ? dayjs(task.dueDate).isBefore(dayjs(), 'day') : false);
  const secondaryText = formatTaskSecondaryText(task);


  return <>
    <ProjectSectionListItem
      disablePadding
      key={document.id}
      secondaryAction={(
        <Stack direction='row' alignItems='center' spacing={1}>
          {secondaryAction}
        </Stack>
      )}
      {...listItemProps}
      onClick={undefined}
    >

      <ListItemButton onClick={() => setIsDrawerOpen(true)} alignItems='center' sx={{ py: 1.5 }}>

        <ListItemText
          primary={
            <Stack direction='row' alignItems='center' spacing={1} minWidth={0}>
              <Typography noWrap>{formatMessage({ id: 'Sign the document {documentName}' }, { documentName: fileName })}</Typography>
              {assigneesAdornment}
            </Stack>
          }
          secondary={
            <Tooltip title={secondaryText || undefined}>
              <Typography noWrap color={isOverdue ? 'error' : 'inherit'}>{secondaryText}</Typography>
            </Tooltip>
          }
          secondaryTypographyProps={{ color: isOverdue ? 'error' : 'inherit' }}
          primaryTypographyProps={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        />
      </ListItemButton>
    </ProjectSectionListItem >
    <DocumentInformationDrawer
      open={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      document={document}
    />
  </>;
};